<template>
  <v-flex xs12>
    <h3 class="text-capitalize ml-4 font-weight-regular">
      {{ $t('Settings') }}
    </h3>

    <v-container fluid>
      <v-data-iterator
        :items="items"
        content-tag="v-layout"
        hide-actions
        row
        wrap
      >
        <template v-slot:item="props">
          <settings-option-card
            :item="props.item"
          />
        </template>
      </v-data-iterator>
    </v-container>
  </v-flex>
</template>

<script>
import SettingsOptionCard from '@/modules/Settings/components/SettingsOptionCard'

export default {
  name: 'SettingsOptionGrid',

  components: {
    SettingsOptionCard
  },

  data () {
    return {
      items: [
        {
          icon: 'settings_brightness',
          title: 'General',
          description: 'Here you can change general setup',
          link: 'settings-general'
        },
        {
          icon: 'flag',
          title: 'Languages',
          description: 'Here you can setup store languages',
          link: 'settings-languages'
        },
        {
          icon: 'people_alt',
          title: 'Customers',
          description: 'Here you can change customers settings',
          link: 'settings-customers'
        },
        {
          icon: 'monetization_on',
          title: 'Taxes',
          description: 'Here you can setup taxes',
          link: 'settings-taxes'
        },
        {
          icon: 'payment',
          title: 'Payments',
          description: 'Here you can setup payments',
          link: 'settings-payment'
        },
        {
          icon: 'business',
          title: 'Locations',
          description: 'Here you can setup localisation',
          link: 'settings-zone'
        },
        {
          icon: 'shopping_basket',
          title: 'Checkout',
          description: 'Here you can setup checkout actions',
          link: 'settings-checkout'
        },
        {
          icon: 'local_shipping',
          title: 'Shipping',
          description: 'Here you can setup shipping actions',
          link: 'settings-shipping'
        },
        {
          icon: 'notifications_paused',
          title: 'Notifications',
          description: 'Here you can setup notifications',
          link: 'settings-notifications'
        },
        {
          icon: 'extension',
          title: 'Plugins',
          description: 'Here you can setup plugins configurations',
          link: 'settings-plugins'
        }
      ]
    }
  }
}
</script>
